import Table from "react-bootstrap/Table";

import { ResumeGrouped } from "@/services/esus/attendanceService";
import { PlaceOfOccurrenceEnum } from "@/utils/enums/PlaceOfOccurrenceEnum";
import { getPlaceOfOccurrence } from "@/utils/placesOfOccurrence";

type Props = {
	aggregatedDeadPatientsByPlace: ResumeGrouped<PlaceOfOccurrenceEnum | null, object>[];
};

export function DeadPatientsByPlaceTable({ aggregatedDeadPatientsByPlace }: Props) {
	return (
		<Table className="text-center">
			<thead>
				<tr>
					<th>Local da ocorrência</th>
					<th>Quantidade de óbitos</th>
				</tr>
			</thead>
			<tbody>
				{aggregatedDeadPatientsByPlace.map((aggregatedPlace, index) => (
					<tr key={`healthunit-deaths-row-${index}`}>
						<td>
							{aggregatedPlace.key
								? getPlaceOfOccurrence(aggregatedPlace.key)
								: "Não informado"}
						</td>
						<td>{aggregatedPlace.total}</td>
					</tr>
				))}
			</tbody>
		</Table>
	);
}
